import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './Assets/Fonts/Roboto/Roboto-Bold.ttf';
import './Assets/Fonts/Roboto/Roboto-Regular.ttf';
import './Assets/Fonts/Roboto/Roboto-Medium.ttf';
import "../node_modules/react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";
import register from './registerServiceWorker';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);
register();
reportWebVitals();
